/**
 * Delivery & Fulfillment Module Manifest
 * 
 * Defines module metadata, routes, and feature flags.
 */

export const DELIVERY_MODULE = {
  id: 'delivery',
  name: 'Delivery & Fulfillment',
  color: '#7c3aed',        // violet-700 — module accent color
  colorLight: '#8b5cf6',   // violet-500
  colorBg: '#7c3aed20',    // violet tint for backgrounds
  logo: '/Aegis (Purple).png',
  basePath: '/delivery',
  routes: [
    { path: '/delivery',            label: 'Overview',   end: true },
    { path: '/delivery/shipments',  label: 'Shipments',  end: false },
    { path: '/delivery/labels',     label: 'Labels',     end: false },
    { path: '/delivery/tracking',   label: 'Live Map',   end: false },
  ],
};

export const DELIVERY_STATUSES = ['Imported', 'Labels Printed', 'In Transit', 'Delivered'];

export const DELIVERY_STATUS_COLORS = {
  'Imported':       { bg: 'bg-slate-700/40',  border: 'border-slate-600', text: 'text-slate-300',  dot: 'bg-slate-400'   },
  'Labels Printed': { bg: 'bg-violet-900/30', border: 'border-violet-600', text: 'text-violet-300', dot: 'bg-violet-400'  },
  'In Transit':     { bg: 'bg-amber-900/30',  border: 'border-amber-600',  text: 'text-amber-300',  dot: 'bg-amber-400'   },
  'Delivered':      { bg: 'bg-green-900/30',  border: 'border-green-600',  text: 'text-green-300',  dot: 'bg-green-400'   },
};
